"use client";

import Header from "@/layout/headers/header";
import Wrapper from "@/layout/wrapper";
// import { promises as fs } from "fs";
// import BlogArea from '@/components/blogs/blog-area';//
import Footer from "@/layout/footers/footer";
import { Suspense } from "react";
import Loading from "./loading";

export default async function PrivayPolicyPage() {
  // const file = await fs.readFile(
  //   process.cwd() + "/src/app/product-data.json",
  //   "utf8"
  // );

  return (
    <Wrapper>
      {/* <Loading /> */}
      {/* header start */}

      <Header />

      {/* header end */}

      <main>
        <Suspense fallback={<Loading />}>
         <section className="privacy__area pt-30 pb-100">
        <div className="container">
          <style jsx>{`
            .privacy-container {
              background: linear-gradient(180deg, #ffffff 0%, #f7f5ff 100%);
              padding: 40px;
              border-radius: 20px;
              box-shadow: 0 8px 25px rgba(160, 128, 255, 0.15);
              border: 1px solid #e6e0ff;
              max-width: 900px;
              margin: 0 auto;
            }

            .privacy-title {
              text-align: center;
              color: #6b4eff;
              font-size: 32px;
              font-weight: 700;
              margin-bottom: 20px;
            }

            .privacy-intro {
              text-align: center;
              color: #4b4b4b;
              margin-bottom: 40px;
              line-height: 1.7;
              font-size: 16px;
            }

            .privacy-section {
              background: white;
              border: 1px solid #e9e4ff;
              padding: 25px;
              border-radius: 16px;
              box-shadow: 0 4px 15px rgba(150, 120, 255, 0.1);
              margin-bottom: 25px;
              transition: all 0.3s ease;
            }

            .privacy-section:hover {
              box-shadow: 0 6px 18px rgba(107, 78, 255, 0.2);
              transform: translateY(-3px);
            }

            .privacy-section h3 {
              color: #6b4eff;
              font-size: 20px;
              font-weight: 600;
              margin-bottom: 10px;
            }

            .privacy-section p {
              color: #444;
              font-size: 15px;
              line-height: 1.8;
            }

            @media (max-width: 768px) {
              .privacy-container {
                padding: 25px;
              }

              .privacy-title {
                font-size: 26px;
              }

              .privacy-section {
                padding: 20px;
              }
            }
          `}</style>

          <div className="privacy-container">
            <h2 className="privacy-title">Privacy Policy</h2>
            <p className="privacy-intro">
              Welcome to <strong>Tashlimafamilyshop LLC</strong> — your trusted
              source for baby items, ladies’ essentials, toys, pet supplies, and
              home goods. We value your trust and are committed to protecting
              your privacy.
            </p>

            <div className="privacy-section">
              <h3>Information We Collect</h3>
              <p>
                We collect basic personal information such as your name, email
                address, shipping details, and payment information to process
                orders and provide customer support.
              </p>
            </div>

            <div className="privacy-section">
              <h3>How We Use Your Information</h3>
              <p>
                Your data is used to process your purchases, improve our
                services, and communicate offers or updates. We never sell or
                misuse your information.
              </p>
            </div>

            <div className="privacy-section">
              <h3>Data Protection</h3>
              <p>
                We store your data on secure servers with strong encryption and
                limited access to ensure safety and confidentiality.
              </p>
            </div>

            <div className="privacy-section">
              <h3>Cookies</h3>
              <p>
                We use cookies to enhance your shopping experience and
                personalize recommendations. You may disable cookies anytime
                through your browser settings.
              </p>
            </div>

            <div className="privacy-section">
              <h3>Your Rights</h3>
              <p>
                You may request to view, edit, or delete your data at any time
                by contacting our support team.
              </p>
            </div>

            <div className="privacy-section">
              <h3>Children’s Privacy</h3>
              <p>
                We do not knowingly collect data from individuals under 18 years
                of age.
              </p>
            </div>

            <div className="privacy-section">
              <p>
                Thank you for trusting <strong>Tashlimafamilyshop LLC</strong>.
                Your privacy and satisfaction are our top priorities. 🛍️
              </p>
            </div>
          </div>
        </div>
      </section>
        </Suspense>
      </main>

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </Wrapper>
  );
}
